import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { gutil } from '../gutil';
import { ActivatedRoute} from "@angular/router";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import * as AOS from 'aos';

@Component({
  selector: 'app-leadership',
  templateUrl: './leadership.component.html',
  styleUrls: ['./leadership.component.scss']
})
export class LeadershipComponent implements OnInit {

     
  constructor() { 
   
  }

  ngOnInit(): void {
      window.scrollTo(0,0);
  }
}